import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/use-current-user';
import { FullPageLoader } from 'prosci-ui';

export function ProsciAdminRoute() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return <FullPageLoader message="Loading..." />;
  }

  // Check if user is a Prosci admin (not a license admin)
  const isProsciAdmin = currentUser?.type === 'prosci_admin';

  if (!isProsciAdmin) {
    // Redirect to users page if not a Prosci admin
    return <Navigate to="/users" replace />;
  }

  return <Outlet />;
}
